import script from "./OrganizationEditionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationEditionPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationEditionPage.vue?vue&type=style&index=0&id=497c807f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497c807f"]])

export default __exports__